import axios from 'axios'

import { getShopDomain } from '@/utils/auth.js'

const SHOP_DOMAIN = getShopDomain()
const API_ENDPOINT = `${SHOP_DOMAIN}/product_filters`

/**
  * Function to retrieve product filter list from application backend.
  */
export const getProductFilters = (params = {}, callback) => {
  axios({
    method: 'get',
    url: API_ENDPOINT,
    params
  })
  .then(function (response) {
    // success
    if (callback && typeof callback === 'function') {
      callback(response.data.product_filters)
    }
  })
  .catch(function (error) {
    // failed
    console.log(error)
  })
}



// WEBPACK FOOTER //
// ./src/js/utils/altview/getProductFilters.js